var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main-body",attrs:{"fluid":""}},[_c('HeaderComponent',{attrs:{"titulo":"I CARRERA POPULAR 7K DEL ROSCÓN"}}),_c('SieteForm'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }